export default __webpack_public_path__ + "alberta-additional-description.9052f11f895e015bdf3c.svg";